/**
 * useArchive
 */

import { useNavigate } from 'react-router-dom';
import { useApi2call, useApi2update } from 'containers/Api2/index.js';
import useGroupTypes from './useGroupTypes.js';

function useArchive(group) {
  const groupType = useGroupTypes(group.groupType);
  const api2call = useApi2call();
  const api2update = useApi2update();
  const navigate = useNavigate();

  const deleteUpdater = (state) => state
    .delete(group.id.toString())
    .updateIn(['list'], (list) => list.filter((v) => v !== group.id));

  const baseOptions = {
    method: 'PUT',
    selector: '-',
    version: 2,
    ignore: [500],
    withPromise: true,
  };

  async function handleArchive() {
    await api2call({
      ...baseOptions,
      url: `sa/groups/${group.id}/archive`,
    });
    api2update({
      selector: `sa/groups/${groupType.id}`,
      updater: deleteUpdater,
    });
    api2update({
      selector: 'sa/groups/archive',
      updater: ((state) => state && state.delete('signature')),
    });
    navigate(`/admin/groups#${groupType.id}`);
  }

  async function handleUnarchive() {
    await api2call({
      ...baseOptions,
      url: `sa/groups/${group.id}/unarchive`,
    });
    api2update({
      selector: 'sa/groups/archive',
      updater: ((state) => state
        .delete(group.id.toString())
        .updateIn(['list'], (list) => list.filter((v) => v !== group.id))),
    });
    api2update({
      selector: `sa/groups/${groupType.id}`,
      updater: ((state) => state && state.delete('signature')),
    });
    navigate(`/admin/groups#${groupType.id}`);
  }

  return { handleArchive, handleUnarchive };
}

export default useArchive;
